module.exports = __webpack_public_path__ + "img/gz.f4cc309a.svg";